import React, { useEffect, useState } from "react";
import { DataSourceExterneDetail } from "../sourceExterne/DataSourceExterneDetail";
import { SplitButton } from "primereact/splitbutton";
import { Button } from "primereact/button";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from '../../../../hooks/hooks';
import { setSidebar, setToast } from "../../../../app/appSlice";

import {
  extendedApi,
  Source,
  logMessage,
  stateMessage,
  useDeleteSourceMutation,
  useStartAndPauseMutation,
  useStateMutation,
  useLazyViewSourceQuery,
} from "../../cdsApiSlice";
import { useInView } from "react-intersection-observer";
import "./DataLibrary.scss";
import { classNames } from "primereact/utils";
import { Chip } from "primereact/chip";
import { useNavigate } from "react-router-dom";
import { useSecureApplication } from "../../../../hooks/KeycloackConnection";
import { DomaineState } from "../DomaineState";
import { IconMode } from '../../../../components/Mode/icon';
import { RuntimeMode } from '../../../../app/apiSlice';

interface Props {
  sourceExterne?: Source;
  id_source_externe: number;
  name: string;
  kind: string;
  description: string;
  icon: string;
  source_protocle?: string;
  type_espace_de_stockage?: string;
  nom_espace_de_stockage?: string;
  stateSourceExterne?: string[];
  logSourceExterne?: string[];
  runtimeMode?: RuntimeMode;
}

export interface IModelSplitButton {
  label: string;
  icon: string;
  disabled: boolean;
  command: () => void;
}

export const DataLibrarySourceItem = ({
  id_source_externe,
  name,
  kind,
  description,
  icon,
  source_protocle,
  type_espace_de_stockage,
  nom_espace_de_stockage,
  sourceExterne,
  runtimeMode
}: Props) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [startAndPause, startAndPauseStatus] = useStartAndPauseMutation();
  const [deleteSource, deleteSourceStatus] = useDeleteSourceMutation();
  const { ref: triggerShowingRow, inView } = useInView();
  const [getState, { data: state, ...statusState }] = useStateMutation();
  const navigate = useNavigate()
  const { hasAnyPerm } = useSecureApplication()
  const [getSource, { data: sourceView, ...sourceStatus }] = useLazyViewSourceQuery();
  const runtimes = useAppSelector((state) => state.app.config.runtimeMode);


  useEffect(() => {
    if (inView && !state && id_source_externe) {
      getState({ id: id_source_externe });
    }
    if (inView && !sourceView && id_source_externe) {
      getSource({ id: id_source_externe });
    }
  }, [inView]);

  const sourceIcon = require("../../../../assets/images/source.svg");
  const Logokafka = require("../../../../assets/images/Logokafka.svg");
  const Logos3 = require("../../../../assets/images/Logos3.svg");
  const jdbc = require("../../../../assets/images/jdbc.svg");
  const sftp = require("../../../../assets/images/sftp.svg");
  const smb = require("../../../../assets/images/smb.svg");
  const https = require("../../../../assets/images/https.svg");

  const [tableRow, setTableRow] = useState<boolean>(false);

  const imageProtocole = (): string | undefined => {
    switch (source_protocle) {
      case "SFTP":
        return sftp.default;
      case "HTTPS":
        return https.default;
      case "JDBC":
        return jdbc.default;
      case "SMB":
        return smb.default;
      default:
        return undefined;
    }
  };

  const deleteSourceExterne = (): boolean => {
    if (id_source_externe) {
      if (
        state &&
        ((state.invalidCount === 0 &&
          state.stoppedCount === 0 &&
          state.runningCount > 0) ||
          state.runningCount > 0 ||
          state.bulletins.length > 0 ||
          state.flowFilesQueued > 0)
      )
        return true;
      return false;
    }
    return false;
  };

  const createModel = (): IModelSplitButton[] => {
    let model: IModelSplitButton[];
    model = [];
    if (id_source_externe && state) {
      if (
        !(
          (state.stoppedCount === 0 &&
            state.invalidCount === 0 &&
            state.runningCount > 0) ||
          state.runningCount > 0 
        ) && hasAnyPerm("gds.startpause","gds.manage")
      ) {
        model.push({
          label: "Démarrer",
          icon: "pi pi-play",
          disabled: id_source_externe ? false : true,
          command: async () => {
            try {
              await startAndPause({
                id: id_source_externe,
                state: "START",
              }).unwrap();
              dispatch(
                setToast({
                  severity: "success",
                  title: "sources",
                  content: "START !",
                  life: 5000,
                })
              );
              getState({ id: id_source_externe });
            } catch {
              dispatch(
                setToast({
                  severity: "error",
                  title: "sources",
                  content: `Echec du lancement de la source ${sourceExterne?.nom}`,
                  life: 5000,
                })
              );
            }
          },
        });
      }

      if (state.runningCount > 0 && hasAnyPerm("gds.startpause","gds.manage")) {
        model.push({
          label: "Pause",
          icon: "pi pi-pause",
          disabled: id_source_externe ? false : true,
          command: async () => {
            try {
              await startAndPause({
                id: id_source_externe,
                state: "PAUSE",
              }).unwrap();
              dispatch(
                setToast({
                  severity: "success",
                  title: "sources",
                  content: "PAUSE !",
                  life: 5000,
                })
              );
              getState({ id: id_source_externe });
            } catch {
              dispatch(
                setToast({
                  severity: "error",
                  title: "sources",
                  content: `Echec de la mise en pause de la source ${sourceExterne?.nom}`,
                  life: 5000,
                })
              );
            }
          },
        });
      }

      if (
        !(
          state.invalidCount === 0 &&
          state.stoppedCount === 0 &&
          state.runningCount > 0
        ) &&
        !(state.runningCount > 0) && hasAnyPerm("gds.manage")
      ) {
        model.push({
          label: t("button.edit"),
          icon: "pi pi-pencil",
          disabled: false,
          command: () => {
            if (sourceExterne) {
              navigate(`/library/source-externe/${sourceExterne.id}`);
            }
          },
        });
      }

      if (!deleteSourceExterne() && hasAnyPerm("gds.manage")) {
        model.push({
          label: t("button.delete"),
          icon: "pi pi-times",
          disabled: deleteSourceExterne(),
          command: async () => {
            try {
              await deleteSource({ id: id_source_externe }).unwrap();
              dispatch(
                setToast({
                  severity: "success",
                  title: "sources",
                  content: "source effacée !",
                  life: 5000,
                })
              );
              dispatch(
                extendedApi.util.updateQueryData(
                  "getAllSources",
                  undefined,
                  (draft) => {
                    draft.data = draft.data.filter(
                      (i) => i.id !== id_source_externe
                    );
                    return draft;
                  }
                )
              );
            } catch {
              dispatch(
                setToast({
                  severity: "error",
                  title: "sources",
                  content: "échec de la suppression !",
                  life: 5000,
                })
              );
            }
          },
        });
      }
    }
    return model;
  };

  const styleComposant = () => {
    const style: any = {};
    if (tableRow) {
      style.borderLeft = "groove";
      style.borderLeftColor = "#007eae";
      style.backgroundColor = "#f9fafb";
    }
    return style;
  };

  const styleOpacity = () => {
    const style: any = { width: "2000px" };
    style.opacity = state && state.runningCount > 0 ? "1" : "0.6";
    return style;
  };

  const openInfoTab = () => {
    dispatch(
      setSidebar({
        title: "",
        content:
          id_source_externe !== 0 && state ? (
            <DataSourceExterneDetail
              id={id_source_externe}
              logMessage={logMessage(state)}
              message={stateMessage(state)}
              state={state}
              sourceView={sourceView!}
            />
          ) : null,
      })
    );
  }

  const DisplayItemIcon = () => {
    const runtime = runtimes.find(r => r.name === runtimeMode);
    return runtime ? <IconMode name={runtime.name} color={runtime.icon.color} fontSize="1.5rem" type={runtime.icon.type}></IconMode> : <></>;
  }

  if (sourceStatus.isError) {
    return <div>Erreur !</div>;
  }

  const model = createModel();

  return (
    <div key={id_source_externe} ref={triggerShowingRow}>
      <table
        className="tableRow"
        id={"table"}
        style={styleComposant()}
        onMouseOver={() => {
          setTableRow(true);
        }}
        onMouseOut={() => {
          setTableRow(false);
        }}
      >
        <td style={styleOpacity()}>
          <tr className="flex" style={{ fontSize: "16px", fontWeight: "bold", alignItems: "center" }}>
            <DisplayItemIcon /> &nbsp;{name}&nbsp;
          </tr>
          <tr>
            <p style={{ color: "#54769a" }}>&nbsp;{description}&nbsp;(...)</p>
          </tr>
          <tr>
            <div className="flex" style={{ alignItems: "center" }}>
              <div
                className={classNames({
                  "ml-1": true,
                  "mr-2": source_protocle ? false : true,
                })}
                style={{ color: "#757575" }}
              >
                {kind.charAt(0).toUpperCase() + kind.slice(1)}
              </div>
              {id_source_externe ? (
                <img
                  src={imageProtocole()}
                  alt=""
                  style={{ alignItems: "center", height: "40px" }}
                  className="mt-1"
                />
              ) : (
                <img
                  src={kind === "source" ? sourceIcon.default : icon}
                  alt=""
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null;
                    currentTarget.src = "/images/connector.svg";
                  }}
                  style={{ alignItems: "center" }}
                />
              )}
              {source_protocle ? (
                <strong style={{ marginLeft: "-9px" }}>
                  {" "}
                  {source_protocle}
                </strong>
              ) : null}

              {type_espace_de_stockage || nom_espace_de_stockage ? (
                <div className="ml-4" style={{ color: "#757575" }}>
                  Stockage
                </div>
              ) : null}
              {type_espace_de_stockage ? (
                type_espace_de_stockage === "S3" ? (
                  <img className="ml-2" src={Logos3.default} />
                ) : (
                  <img className="ml-2" src={Logokafka.default} />
                )
              ) : null}
              {nom_espace_de_stockage ? (
                <strong className="ml-2">{nom_espace_de_stockage}</strong>
              ) : null}
              {sourceExterne?.domaine?.libelle && (
                <div className="flex">
                  <div className="ml-4" style={{ color: "#757575" }}>
                    Domaine
                  </div>
                  <strong className="ml-2">
                    {sourceExterne.domaine.libelle}
                  </strong>
                  <div className="ml-3">
                    <DomaineState
                      nifiStatus={sourceExterne.domaine.statutNifi}
                      domaineName={sourceExterne.domaine.libelle}
                    />
                  </div>
                </div>
              )}
              {sourceExterne?.domaine?.zone ? (
                <div className="ml-4" style={{ color: "#757575" }}>
                  Zone
                </div>
              ) : null}
              {sourceExterne?.domaine?.zone ? (
                <strong className="ml-2">{sourceExterne.domaine.zone}</strong>
              ) : null}
            </div>
          </tr>
        </td>
        <td style={{ width: "1px", verticalAlign: "middle" }}>
          <tr>
            <div className="flex">
              {state &&
              (state.invalidCount > 0 ||
                state.bulletins.length > 0 ||
                state.disabledCount > 0) ? (
                <div className="mt-2 mr-2">
                  {" "}
                  <Chip
                    style={{ backgroundColor: "#f6d5d9", color: "#d32d41" }}
                    label="Erreur"
                  />{" "}
                </div>
              ) : null}

              {state && state.runningCount === 0 ? (
                <div className="mt-2 mr-2">
                  <Chip label="pause" />
                </div>
              ) : null}

              {state &&
              state.stoppedCount === 0 &&
              state.invalidCount === 0 &&
              state.runningCount > 0 ? (
                <div className="mt-2 mr-2">
                  <Chip
                    style={{ backgroundColor: "#e4f3ff", color: "#007fb0" }}
                    label="démarée"
                  />
                </div>
              ) : null}
              {model.length > 0 && id_source_externe ? (
                  <SplitButton
                    label={t("button.open")}
                    icon="pi pi-info-circle"
                    model={model}
                    className="p-button-primary p-button-text ml-2"
                    onClick={openInfoTab}
                    style={{ alignItems: "center" }}
                  />
                ):null}

              {model.length === 0 && id_source_externe ?  (
                  <Button
                    label={t("button.open")}
                    icon={"pi pi-info-circle"}
                    className="p-button-primary p-button-text ml-2"
                    onClick={openInfoTab}
                  />
                ):null}
            </div>
          </tr>
        </td>
      </table>
    </div>
  );
};
